// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__R8tw-","title":"AfterFrontImage_title__2E7mN"};